import { __awaiter, __generator } from "tslib";
import { FileType } from '@office-start/document-types';
import { getLaunchParams } from './getLaunchParams';
import { launchUrlInWeb } from './launchUrlInWeb';
/**
 * launchInWeb will launch the item url given in a new or same tab based on
 * the given inputs
 * @param ContentLaunchParams
 * @param launchInstrumentationParams
 * @returns A promise containing the result of the attempted launch
 */
export function launchInWeb(contentLaunchParams, launchInstrumentationParams) {
    return __awaiter(this, void 0, void 0, function () {
        var launchParams;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getLaunchParams(contentLaunchParams)];
                case 1:
                    launchParams = _a.sent();
                    if (launchParams.webUrl) {
                        return [2 /*return*/, launchUrlInWeb('OpenDocument', launchParams.webUrl, launchInstrumentationParams, contentLaunchParams.document.fileType === FileType.FormsQuiz
                                ? '_self'
                                : undefined)];
                    }
                    return [2 /*return*/, { success: false, result: 'Web' }];
            }
        });
    });
}
//# sourceMappingURL=launchInWeb.js.map